'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _theme = require('../theme');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line local-rules/no-deep-relative-imports

var AriaClickHandler = function (_React$PureComponent) {
  (0, _inherits3.default)(AriaClickHandler, _React$PureComponent);

  function AriaClickHandler() {
    (0, _classCallCheck3.default)(this, AriaClickHandler);
    return (0, _possibleConstructorReturn3.default)(this, (AriaClickHandler.__proto__ || Object.getPrototypeOf(AriaClickHandler)).apply(this, arguments));
  }

  (0, _createClass3.default)(AriaClickHandler, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          ariaLabel = _props.ariaLabel,
          children = _props.children,
          expanded = _props.expanded,
          hasPopup = _props.hasPopup,
          onClick = _props.onClick,
          restProps = (0, _objectWithoutProperties3.default)(_props, ['ariaLabel', 'children', 'expanded', 'hasPopup', 'onClick']);


      if (!onClick) {
        return children;
      }

      return _react2.default.createElement(
        AriaClickHandlerStyled,
        (0, _extends3.default)({
          'aria-expanded': expanded,
          'aria-haspopup': hasPopup,
          'aria-label': ariaLabel,
          onClick: onClick
        }, restProps),
        children
      );
    }
  }]);
  return AriaClickHandler;
}(_react2.default.PureComponent);

var AriaClickHandlerStyled = /*#__PURE__*/(0, _theme.styled)('button', {
  target: 'e1bz1vos0'
})({
  background: 'transparent',
  border: 'none',
  borderRadius: 'inherit',
  color: 'inherit',
  display: 'inline-block',
  font: 'inherit',
  padding: 0,
  textAlign: 'initial',
  width: 'inherit'
}, function (_ref) {
  var theme = _ref.theme,
      disabled = _ref.disabled;

  if (disabled) {
    return (0, _extends3.default)({
      cursor: 'not-allowed'
    }, theme.components.ariaClickHandler.disabled);
  } else {
    return (0, _extends3.default)({
      cursor: 'pointer'
    }, theme.components.ariaClickHandler.enabled);
  }
});

exports.default = AriaClickHandler;